var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card-title', [_vm._v(" Управляемые системы "), _c('v-spacer'), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        return _vm.fetch();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-refresh")])], 1), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.openEdit(null);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Добавить ")], 1)], 1), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.systems,
      "loading": _vm.loading,
      "disable-pagination": "",
      "hide-default-footer": "",
      "no-data-text": "Систем пока нет"
    },
    scopedSlots: _vm._u([{
      key: "item.name",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('div', [_vm._v(_vm._s(item.name)), item.planName ? _c('span', {
          staticClass: "text--secondary"
        }, [_vm._v(" · " + _vm._s(item.planName))]) : _vm._e()]), _c('a', {
          staticClass: "font-size__small",
          attrs: {
            "href": item.url,
            "target": "_blank",
            "rel": "noopener"
          }
        }, [_vm._v(_vm._s(item.url))])];
      }
    }, {
      key: "item.balance",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(_vm._s(_vm.money(item.balance)))];
      }
    }, {
      key: "item.dailyRate",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._v(_vm._s(_vm.money(item.dailyRate)))];
      }
    }, {
      key: "item.paidUntil",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm._v(_vm._s(_vm.formatDate(item.paidUntil) || '—'))];
      }
    }, {
      key: "item.status",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [!item.enabled ? _c('v-chip', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("Не управляется")]) : item.status === 'BLOCKED' ? _c('v-chip', {
          attrs: {
            "small": "",
            "color": "red",
            "text-color": "white"
          }
        }, [_vm._v("Заблокирована")]) : _c('v-chip', {
          attrs: {
            "small": "",
            "color": "green",
            "text-color": "white"
          }
        }, [_vm._v("Активна")])];
      }
    }, {
      key: "item.sync",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "400"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref7) {
              var on = _ref7.on;
              return [_c('v-icon', _vm._g({
                attrs: {
                  "color": item.lastSyncError ? 'red' : item.lastSyncAt ? 'green' : 'grey'
                }
              }, on), [_vm._v(" " + _vm._s(item.lastSyncError ? 'mdi-sync-alert' : 'mdi-sync') + " ")])];
            }
          }], null, true)
        }, [item.lastSyncError ? _c('span', [_vm._v("Ошибка: " + _vm._s(item.lastSyncError))]) : item.lastSyncAt ? _c('span', [_vm._v("Синхронизировано " + _vm._s(_vm.formatDateTime(item.lastSyncAt)))]) : _c('span', [_vm._v("Ещё не синхронизировалась")])])];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_c('v-btn', {
          staticClass: "mr-1",
          attrs: {
            "small": "",
            "color": "green"
          },
          on: {
            "click": function click($event) {
              return _vm.openMoney(item, 'topUp');
            }
          }
        }, [_vm._v("Пополнить")]), _c('v-menu', {
          attrs: {
            "offset-y": "",
            "left": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref9) {
              var on = _ref9.on;
              return [_c('v-btn', _vm._g({
                attrs: {
                  "icon": "",
                  "small": ""
                }
              }, on), [_c('v-icon', [_vm._v("mdi-dots-vertical")])], 1)];
            }
          }], null, true)
        }, [_c('v-list', {
          attrs: {
            "dense": ""
          }
        }, [_c('v-list-item', {
          on: {
            "click": function click($event) {
              return _vm.openEdit(item);
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Редактировать")])], 1), _c('v-list-item', {
          on: {
            "click": function click($event) {
              return _vm.openMoney(item, 'adjust');
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Корректировка баланса")])], 1), _c('v-list-item', {
          on: {
            "click": function click($event) {
              return _vm.openHistory(item);
            }
          }
        }, [_c('v-list-item-title', [_vm._v("История операций")])], 1), _c('v-list-item', {
          on: {
            "click": function click($event) {
              return _vm.sync(item);
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Синхронизировать сейчас")])], 1)], 1)], 1)];
      }
    }], null, true)
  }), _c('v-dialog', {
    attrs: {
      "max-width": "520"
    },
    model: {
      value: _vm.edit.open,
      callback: function callback($$v) {
        _vm.$set(_vm.edit, "open", $$v);
      },
      expression: "edit.open"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.edit.id ? 'Редактирование системы' : 'Новая система'))]), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Название"
    },
    model: {
      value: _vm.edit.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.edit.form, "name", $$v);
      },
      expression: "edit.form.name"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "URL бэкенда",
      "hint": "Например https://crm.client.ru — без /api",
      "persistent-hint": ""
    },
    model: {
      value: _vm.edit.form.url,
      callback: function callback($$v) {
        _vm.$set(_vm.edit.form, "url", $$v);
      },
      expression: "edit.form.url"
    }
  }), _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "Тариф",
      "counter": "100",
      "hint": "Видят админы клиента: «Доступ «Энтерпрайз»». Можно оставить пустым",
      "persistent-hint": ""
    },
    model: {
      value: _vm.edit.form.planName,
      callback: function callback($$v) {
        _vm.$set(_vm.edit.form, "planName", $$v);
      },
      expression: "edit.form.planName"
    }
  }), _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "Стоимость в день, ₽",
      "type": "number",
      "min": "0"
    },
    model: {
      value: _vm.edit.form.dailyRate,
      callback: function callback($$v) {
        _vm.$set(_vm.edit.form, "dailyRate", $$v);
      },
      expression: "edit.form.dailyRate"
    }
  }), _c('v-switch', {
    attrs: {
      "label": "Управлять системой (списания и блокировка)",
      "hint": "При выключении система разблокируется и больше не списывается",
      "persistent-hint": ""
    },
    model: {
      value: _vm.edit.form.enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.edit.form, "enabled", $$v);
      },
      expression: "edit.form.enabled"
    }
  }), _vm.edit.error ? _c('v-alert', {
    staticClass: "mt-4 mb-0",
    attrs: {
      "type": "error",
      "dense": "",
      "text": ""
    }
  }, [_vm._v(_vm._s(_vm.edit.error))]) : _vm._e()], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.edit.open = false;
      }
    }
  }, [_vm._v("Отмена")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.edit.busy
    },
    on: {
      "click": function click($event) {
        return _vm.saveEdit();
      }
    }
  }, [_vm._v("Сохранить")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "max-width": "440"
    },
    model: {
      value: _vm.moneyDialog.open,
      callback: function callback($$v) {
        _vm.$set(_vm.moneyDialog, "open", $$v);
      },
      expression: "moneyDialog.open"
    }
  }, [_vm.moneyDialog.system ? _c('v-card', [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.moneyDialog.mode === 'topUp' ? 'Пополнение' : 'Корректировка') + " — " + _vm._s(_vm.moneyDialog.system.name) + " ")]), _c('v-card-text', [_c('div', {
    staticClass: "mb-4"
  }, [_vm._v("Текущий баланс: "), _c('b', [_vm._v(_vm._s(_vm.money(_vm.moneyDialog.system.balance)))])]), _c('v-text-field', {
    attrs: {
      "label": "Сумма, ₽",
      "type": "number",
      "hint": _vm.moneyDialog.mode === 'adjust' ? 'Отрицательная сумма уменьшает баланс' : '',
      "persistent-hint": "",
      "autofocus": ""
    },
    model: {
      value: _vm.moneyDialog.amount,
      callback: function callback($$v) {
        _vm.$set(_vm.moneyDialog, "amount", $$v);
      },
      expression: "moneyDialog.amount"
    }
  }), _c('v-text-field', {
    staticClass: "mt-2",
    attrs: {
      "label": "Комментарий"
    },
    model: {
      value: _vm.moneyDialog.comment,
      callback: function callback($$v) {
        _vm.$set(_vm.moneyDialog, "comment", $$v);
      },
      expression: "moneyDialog.comment"
    }
  }), _vm.moneyDialog.error ? _c('v-alert', {
    staticClass: "mb-0",
    attrs: {
      "type": "error",
      "dense": "",
      "text": ""
    }
  }, [_vm._v(_vm._s(_vm.moneyDialog.error))]) : _vm._e()], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.moneyDialog.open = false;
      }
    }
  }, [_vm._v("Отмена")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.moneyDialog.busy
    },
    on: {
      "click": function click($event) {
        return _vm.saveMoney();
      }
    }
  }, [_vm._v("Сохранить")])], 1)], 1) : _vm._e()], 1), _c('v-dialog', {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.history.open,
      callback: function callback($$v) {
        _vm.$set(_vm.history, "open", $$v);
      },
      expression: "history.open"
    }
  }, [_vm.history.system ? _c('v-card', [_c('v-card-title', [_vm._v(" История операций — " + _vm._s(_vm.history.system.name) + " "), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.history.open = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-data-table', {
    attrs: {
      "headers": _vm.historyHeaders,
      "items": _vm.history.items,
      "loading": _vm.history.loading,
      "server-items-length": _vm.history.total,
      "options": _vm.history.options,
      "footer-props": {
        'items-per-page-options': [20, 50, 100]
      },
      "no-data-text": "Операций нет"
    },
    on: {
      "update:options": function updateOptions($event) {
        return _vm.$set(_vm.history, "options", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "item.createdAt",
      fn: function fn(_ref0) {
        var item = _ref0.item;
        return [_vm._v(_vm._s(_vm.formatDateTime(item.createdAt)))];
      }
    }, {
      key: "item.type",
      fn: function fn(_ref1) {
        var item = _ref1.item;
        return [_vm._v(" " + _vm._s(_vm.transactionTypes[item.type]) + " "), item.chargeDate ? _c('span', {
          staticClass: "font-size__small"
        }, [_vm._v(" за " + _vm._s(_vm.formatDate(item.chargeDate)))]) : _vm._e()];
      }
    }, {
      key: "item.amount",
      fn: function fn(_ref10) {
        var item = _ref10.item;
        return [_c('span', {
          class: item.amount < 0 ? 'red--text' : 'green--text'
        }, [_vm._v(_vm._s(_vm.money(item.amount)))])];
      }
    }, {
      key: "item.balanceAfter",
      fn: function fn(_ref11) {
        var item = _ref11.item;
        return [_vm._v(_vm._s(_vm.money(item.balanceAfter)))];
      }
    }, {
      key: "item.createdByName",
      fn: function fn(_ref12) {
        var item = _ref12.item;
        return [_vm._v(_vm._s(item.createdByName || 'Система'))];
      }
    }], null, true)
  })], 1) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }